import React from 'react'
import { StaticQuery, graphql } from 'gatsby'

import References from '~components/References'

import style from './ReferenceCategories.module.scss'

const ReferenceCategories = () => (
  <StaticQuery
    query={query}
    render={data => (
      <div className={style.categories}>
        <References tags={data.tags.nodes} />
      </div>
    )}
  />
)

const query = graphql`
query {
  tags: allTag(
    limit: 8,
    sort: {fields: name}
  ) {
    nodes {
      id
      name
      resources {
        id
        path
        title
      }
      endpoints {
        id
        urlPath
        title
        verb
      }
    }
  }
}
`

export default ReferenceCategories